import React, { useState, useEffect, useCallback, useContext } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, IconButton,
  Dialog, DialogActions, DialogContent, DialogTitle, TextField, Box, CircularProgress, Typography,
  Select, MenuItem, FormControl, InputLabel,
  Grid,
  Snackbar
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { storeGroupApi } from '../../apiUser';
import { InfoContext } from '../../context/InfoContext';

const StoresGroups = () => {
  const [storesGroups, setStoresGroups] = useState([]);
  const [deviceGroups, setDeviceGroups] = useState([]);
  const [deviceTypes, setDeviceTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [openForm, setOpenForm] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [currentStoreGroup, setCurrentStoreGroup] = useState(null);
  const {info, setInfo} = useContext(InfoContext);

  const [snackBar, setSnackBar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });



  useEffect(() => {
    const fetchGroups = async () => {
      setLoading(true);
      try {
        const groups = await storeGroupApi.get(info.selectedClient.client_id);
        setStoresGroups(groups.data);
      } catch (err) {
        setError(err.message || 'Errore durante il caricamento dei gruppi di dispositivi');
      } finally {
        setLoading(false);
      }
    };

    fetchGroups();
  }, []);

  const handleOpenEdit = (device) => {
    setCurrentStoreGroup(device);
    setOpenForm(true);
  }
  const handleOpenDelete = (device) => {
    setCurrentStoreGroup(device);
    setOpenDelete(true);
  };
  const handleOpenForm = () => {
    setCurrentStoreGroup(null);
    setOpenForm(true);
  };

  return(
    <Box sx={{ padding: 2 }}>
      <Grid container spacing={2}>
        <Grid item size={{xs: 12, sm: 6, md: 4}}>
          <Typography variant="h4" gutterBottom>
            Gruppi di Negozi
          </Typography>
        </Grid>
        <Grid item size={{xs: 12, sm: 6, md: 8}} display="flex" justifyContent="flex-end">
          <Button variant="contained" color="primary" onClick={() => handleOpenForm()}>
            Aggiungi Gruppo
          </Button>
        </Grid>
        <Grid item size={{ xs: 12 }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Descrizione</TableCell>
                  <TableCell>Azioni</TableCell>
                  
                </TableRow>
              </TableHead>
              <TableBody>
                {storesGroups.map((group) => (
                  <TableRow key={group.id}>
                    <TableCell>{group.id}</TableCell>
                    <TableCell>{group.description}</TableCell>
                    <TableCell>
                      <IconButton onClick={() => handleOpenEdit(group)}>
                        <EditIcon />
                      </IconButton>
                      <IconButton onClick={() => handleOpenDelete(group)}>
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
      <Dialog open={openForm} onClose={() => setOpenForm(false)}>
        <DialogTitle>{currentStoreGroup ? 'Modifica Gruppo' : 'Aggiungi Gruppo'}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="ID"
            type="text"
            fullWidth
            variant="standard"
            value={currentStoreGroup ? currentStoreGroup.id : ''}
            onChange={(e) => setCurrentStoreGroup({ ...currentStoreGroup, id: e.target.value })}
          />
          <TextField
            autoFocus
            margin="dense"
            label="Descrizione"
            type="text"
            fullWidth
            variant="standard"
            value={currentStoreGroup ? currentStoreGroup.description : ''}
            onChange={(e) => setCurrentStoreGroup({ ...currentStoreGroup, description: e.target.value })}
          />
          
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenForm(false)}>Annulla</Button>
          <Button onClick={() => {
            storeGroupApi.create(info.selectedClient.client_id, currentStoreGroup)
              .then(() => {
                setSnackBar({
                  open: true,
                  message: 'Gruppo salvato con successo',
                  severity: 'success'
                });
                setOpenForm(false);
                
              })
              .catch((err) => {
                setSnackBar({
                  open: true,
                  message: `Errore durante il salvataggio del gruppo: ${err.message}`,
                  severity: 'error'
                });
              });
            setOpenForm(false);
          }}>Salva</Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackBar.open}
        autoHideDuration={6000}
        onClose={() => setSnackBar({ ...snackBar, open: false })}
        message={snackBar.message}
        severity={snackBar.severity}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      />
    </Box>
  )


}

export default StoresGroups;